var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullsize",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"margin":"0","font-weight":"bold","font-size":"200%","position":"absolute","top":"5%","left":"5%","z-index":"100000"}},[_vm._t("default")],2),_c('LoadingCards',{staticClass:"loadingBar",staticStyle:{"z-index":"1000"},attrs:{"counting":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }